import { useMemo } from 'react';

import { useCurrentUser } from '@/services/auth';

export function useCrmUrl() {
  const user = useCurrentUser();
  const crmUrl = useMemo(() => {
    const activeCompany = user.data?.companies.find((c) => c.isActive);
    const activeCrmUrl = activeCompany?.crmUrl;
    return activeCrmUrl;
  }, [user.data?.companies]);
  return crmUrl;
}
